import { NotificationResponseDto } from "../models/notification/NotificationResponseDto";
import { subscribeStomp } from "./stompClient";

type Listener = (notification: NotificationResponseDto) => void;

const DESTINATION = "/user/queue/notifications";

// Đăng ký listener nhận notification
export const addNotificationListener = (listener: Listener): (() => void) =>
  subscribeStomp<NotificationResponseDto>(DESTINATION, listener);
